import React from 'react';

import IntegrationsCell from 'app/components/data-table/IntegrationsCell';
import TagsCell from 'app/components/data-table/TagsCell';
import TimestampCell from 'app/components/data-table/TimestampCell';
import TextCell from 'app/components/data-table/TextCell';

import PipelineNameCell from './cells/PipelineNameCell';
import DeploymentStatusCell from './cells/DeploymentStatusCell';

export default function buildBulkDeployTableColumns({ showTags }) {
  return [
    {
      name: 'Pipeline Name',
      cell: row => <PipelineNameCell {...row} />,
      grow: 2,
      sortable: true,
      sortField: 'name',
    },
    {
      name: 'Integrations',
      cell: row => (
        <IntegrationsCell AvatarProps={{ size: 'large' }} bubbleClickEvent integrations={row.integrations} />
      ),
      grow: 1,
    },
    ...(showTags
      ? [
          {
            name: 'Tags',
            cell: row => <TagsCell tags={row.pipelineTags} />,
            width: '250px',
          },
        ]
      : []),
    {
      name: 'Writekey',
      cell: row => <TextCell bubbleClickEvent text={row.writeKey} />,
      grow: 1,
      sortable: true,
      sortField: 'writeKey',
    },
    {
      name: 'Cluster',
      cell: row => <TextCell bubbleClickEvent text={row.cluster.name} />,
      grow: 1,
      sortable: true,
      sortField: 'cluster',
    },
    {
      name: 'Last Deployed',
      cell: row => <TimestampCell timestamp={row.lastDeployed} />,
      grow: 1,
    },
    {
      name: 'Status',
      cell: row => <DeploymentStatusCell status={row.deploymentStatus.status} />,
      grow: 0,
      center: true,
    },
  ];
}
